import InstructorBadges from '../instructor/welcome/badges';
import './styles.css';

import BadgeNoob from './images/badge-noob.png';
import BadgeNewbie from './images/badge-newbie.png';
import BadgeWarrior from './images/badge-warrior.png';
import BadgeMaster from './images/badge-master.png';

export const badges = [
  {
    title: 'Noob',
    image: BadgeNoob,
    points: 'below 50'
  },
  {
    title: 'Newbie',
    image: BadgeNewbie,
    points: '50-69.99'
  },
  {
    title: 'Warrior',
    image: BadgeWarrior,
    points: '70-89.99'
  },
  {
    title: 'Master',
    image: BadgeMaster,
    points: '90 or more'
  }
];

export default function PerformanceRankingInfo({
  position = 'relative-top',
  onCloseButtonClick = null
}) {
  return (
    <div className={`performance-ranking-info ${position}`}>
      {
        onCloseButtonClick && (
          <button 
            className="close-button"
            onClick={onCloseButtonClick}
          ></button>
        )
      }
      <h5>Performance Ranking</h5>
      <div className="performance-ranking-info-text">
        <span>Ranking is based on points earned for the accuracy and speed of each decision.</span>
      </div>
      <ul className="performance-ranking-badges">
        {badges.map((badge, index) => (
          <li key={index}>
            <img src={badge.image} alt={badge.title} />
            <h6>{badge.title}</h6>
            <p>{badge.points}</p>
          </li>
        ))}
      </ul>
      <p className="performance-ranking-avarage-points-text">Average Points Per Decision</p>
    </div>
  );
}
